import type { UseFormReturn } from "react-hook-form";
import { ChoiceStepFields } from "../choice-step-fields";
import { MultiStepFields } from "../multi-step-fields";
import { RequiredToggle } from "../required-toggle";
import type { StepsFormValues } from "../survey-schema";
import { TextStepFields } from "../text-step-fields";
import type { useStepsRules } from "./use-steps-rules";

export interface StepFieldsProps {
    form: UseFormReturn<StepsFormValues>;
    index: number;
    rules: ReturnType<typeof useStepsRules>;
}

/** One step's editable fields: its kind's editor, the score switch (choice
 *  steps) and Required. Reads the whole-list form so cross-step rules — one
 *  score, a split threshold from the score's values — work as before. */
export function StepFields({ form, index, rules }: StepFieldsProps) {
    const step = rules.values.steps[index];
    if (!step) return null;
    return (
        <div className="flex flex-col gap-4">
            {step.kind === "choice" ? (
                <ChoiceStepFields
                    form={form}
                    stepIndex={index}
                    onToggleMetric={(next) => rules.toggleMetric(index, next)}
                />
            ) : step.kind === "multi" ? (
                <MultiStepFields
                    form={form}
                    stepIndex={index}
                    metricValues={rules.scoredAt >= 0 && rules.scoredAt < index ? rules.scoreValues : null}
                />
            ) : (
                <TextStepFields control={form.control} stepIndex={index} />
            )}
            <RequiredToggle
                checked={step.required}
                splitByScore={step.kind === "multi" && step.multiMode === "split"}
                onCheckedChange={(next) => form.setValue(`steps.${index}.required`, next, { shouldDirty: true })}
            />
        </div>
    );
}
